<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <div #studentHeader style="padding:10px;">
        <student-header [showStudent]="userType == 1 && !staffPage ? true : false" [pageTitle]="'e-Forms'" [eForm]="true"></student-header>
    </div>
    <tabs [tabNames]="tabNames" [setIndex]="setIndex"  (selectionsChangeIndex)="selectionChange($event)"></tabs>
    <div class='flex-content'>
        <div style="display: flex;">
            <span style="text-align:center; width: 100%; padding-top: 20px;" *ngIf="filteredEForms && filteredEForms.length == 0 && selectionIndex == 0">There are no required e-Forms to be submitted.</span>
            <span style="text-align:center; width: 100%; padding-top: 20px;" *ngIf="filteredEForms && filteredEForms.length == 0 && selectionIndex == 1">There are no optional e-Forms available.</span>
        </div>
        <mat-table #table *ngIf="filteredEForms && filteredEForms.length > 0" [dataSource]="dataSource" matSortDisableClear matSort id="tblEFormInstances" matSortActive="InstanceName"
            matSortDirection="asc" style="min-width: 900px;">
            <ng-container matColumnDef="Year">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Year</span>
                    <filter class="mat-filter" [data]="dataSource" columnName="Year" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> 
                    <span *ngIf="(element.ShowInAllYears && element.AllowMultiple) && (!element.ID || element.ID <= 0)">Multiple</span>
                    <span *ngIf="(!element.ShowInAllYears || (element.ID && element.ID > 0)) && V10">{{element.AYIdentifier}}</span>
                    <span *ngIf="(!element.ShowInAllYears || (element.ID && element.ID > 0)) && !V10">{{element.Year_ID | yearDescription}}</span>                            
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="InstanceName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Name</span>
                    <filter class="mat-filter" [data]="dataSource" columnName="InstanceName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <a (click)="formClick(element)">
                        {{element.InstanceName | tylTranslate}}                        
                        <span *ngIf="element.ID == 0 && element.CompletionDue && element.CompletionDueOption == 'OncePer'" translate>&nbsp;-&nbsp;{{currentDateString}}</span>
                        <span *ngIf="element.ID > 0 && element.CompletionDue && element.CompletionDueOption == 'OncePer' && V10" translate>&nbsp;-&nbsp;{{element.SubmittedDate | date: 'MM/dd/yy'}}</span>
                        <span *ngIf="element.ID > 0 && element.CompletionDue && element.CompletionDueOption == 'OncePer' && !V10" translate>&nbsp;-&nbsp;{{element.SubmittedOn | date: 'MM/dd/yy'}}</span>
                    </a>
                    <span *ngIf="element.AllowMultiple && element.ID == 0" translate>&nbsp;[Create new]</span>                    
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="TemplateType">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Type</span>
                    <filter class="mat-filter" [data]="dataSource" columnName="TemplateType" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <span *ngIf="element.TemplateType == 'family'" translate>Family</span>
                    <span *ngIf="element.TemplateType == 'student'" translate>Student</span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Student">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Student</span>
                    <filter class="mat-filter" [data]="dataSource" columnName="Student" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <span *ngIf="element.TemplateType != 'family'">{{element.Student}}</span>
                    <div *ngIf="element.TemplateType == 'family'">
                        <div *ngFor="let student of element.StudentNames" style="padding-top: 2px; padding-bottom: 2px;">{{student}}</div>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DueDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Deadline</span>
                    <filter class="mat-filter" [data]="dataSource" columnName="DueDate" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="dueDateCheck(element)">
                    <span *ngIf="!pastDueCheck(element)">
                        {{element.DueDate | date: 'MM/dd/yy'}}
                    </span>
                    <span *ngIf="pastDueCheck(element)">
                        <span translate>Due Now</span>
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SubmittedDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Submitted</span>
                    <filter class="mat-filter" [data]="dataSource" columnName="SubmittedDate" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> 
                    <span *ngIf="V10">{{element.SubmittedDate | date: 'MM/dd/yy'}}</span> 
                    <!-- <span *ngIf="!V10 && element.Status">{{element.SubmittedOn | date: 'MM/dd/yy'}}</span>  -->
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SubmittedOn">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Submitted</span>
                    <filter class="mat-filter" [data]="dataSource" columnName="SubmittedOn" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <span *ngIf="!V10 && element.Status">{{element.SubmittedOn | date: 'MM/dd/yy'}}</span> 
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SubmittedName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Submitted By</span>
                    <filter class="mat-filter" [data]="dataSource" columnName="SubmittedName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> 
                    <!-- <span *ngIf="V10">{{element.SubmittedName}}</span> 
                    <span *ngIf="!V10 && element.Status">{{element.SubmittedByName}}</span>  -->
                    {{element.SubmittedName}} 
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Status">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Status</span>
                    <filter class="mat-filter" [data]="dataSource" columnName="Status" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <span *ngIf="element.ID != 0" translate>{{element.Status}}</span>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columnsToDisplay;sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = renderIndex;"
                [ngStyle]="{'background-color': row.AllowMultiple && row.ID == 0 ? '#e8eaf6': ''}">
                id="tblEFormCategoriesDataRow{{i}}" tabindex="0">
            </mat-row>

        </mat-table>
    </div>
</tyl-kendo-pdf-export>
<div class='flex-footer'>
    <div class='flex-footer-left'>

    </div>
    <div class="flex-footer-middle" style="align-items: center">
        <tyl-checkbox
            id='chkShowCompleted'
            name='chkShowCompleted'
            [disabled]='pastYear'
            [(checked)]='showCompleted'
            (change)="showCompletedChange()">
            <span translate>Show completed e-Forms</span>
        </tyl-checkbox>
    </div>
    <div class='flex-footer-right'>

    </div>
</div>
